import React from 'react';
import styled from 'styled-components';

const SpacerWrapper = styled.div`
  margin: 24px 0;
`

const Spacer = () => {
  return (
    <SpacerWrapper />
  );
}

export default Spacer;
